import Scriba from 'react-scriba';

export class DataCategorieIntervenantEXTPersonne {

    static _detailler = (idCategorieIntervenantEXTPersonne) => {
        const objet = { idCategorieIntervenantEXTPersonne };
        const url = "api/Fiche/DetaillerCategorieIntervenantEXTPersonne";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _enregistrer = (categorieIntervenantEXTPersonne) => {
        const objet = { categorieIntervenantEXTPersonne };
        const url = "api/MAJDonnees/EnregistrerCategorieIntervenantEXTPersonne";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

    static _lister = () => {
        const objet = {};
        const url = "api/Liste/ListerCategorieIntervenantEXTPersonne";
        const paramPost = Scriba.fetch().createParameterPost(objet);
        return fetch(url, paramPost).then(response => response.json());
    };

};